import type { OrganizationDetail } from '@/definitions/organization'
import { PRODUCT_FLAG_ROWS, type ProductFlagFormValues } from '@/definitions/productFlags'

/**
 * Reads the organization's stored flags into the form's shape.
 *
 * Three flags are nullable on the backend and an unset one means off, so null
 * flattens to false rather than reaching the form as a third state. The account
 * SID flattens to an empty string for the same reason — a text field cannot hold
 * null.
 */
export const buildFlagFormValues = (org: OrganizationDetail): ProductFlagFormValues => {
  const values = {} as ProductFlagFormValues

  for (const row of PRODUCT_FLAG_ROWS) {
    values[row.field] = org[row.field] === true
  }

  values.twilio_account_sid = org.twilio_account_sid ?? ''

  return values
}
